import { lazyWithReload } from "@/utils/lazyWithReload";

/**
 * The ONLY import site of `./PdfPagesRenderer` (and therefore of `react-pdf` /
 * `pdfjs-dist`) outside the pdf/ directory. Keeps the `pdf-viewer` chunk
 * (vite.config.ts `manualChunks`) out of the entry bundle, and lets
 * `PdfRendererBoundary` fall back to the native viewer when the chunk cannot
 * be fetched.
 */
export const PdfPagesRendererLazy = lazyWithReload(() => import("./PdfPagesRenderer"));
